
/* injects from baggage-loader */

import React from 'react'
import PropTypes from 'prop-types'
import TopPanel from 'containers/TopPanel'
import isFunction from 'lodash/isFunction'
import {formatPattern} from 'react-router/lib/PatternUtils'
import {StickyContainer} from 'react-sticky'

export default class ConfigurationLayout extends React.Component {
  static propTypes = {
    route: PropTypes.object,
    routes: PropTypes.arrayOf(PropTypes.object),
    params: PropTypes.object,
    menu: PropTypes.node,
    main: PropTypes.node
  }

  render() {
    const {menu} = this.props
    const routesDetails = this.getRoutesDetails()

    return (
      <div className='configuration-layout'>
        <StickyContainer className='configuration-layout_sticky-container'>
          <TopPanel
            title={this.getTitle()}
            menu={menu}
            breadcrumbs={routesDetails}
          />
          {this.props.children || this.props.main}
        </StickyContainer>
      </div>
    )
  }

  getRoutesDetails() {
    const {route, routes, params} = this.props
    const fullPath = []

    if (!routes.concat().pop().withBreadcrumbs) return null

    return routes.concat()
      .splice(routes.indexOf(route), routes.length)
      .filter(route => !!route.title && !!route.path)
      .reduce((acc, r) => {
        fullPath.push(r.path)
        return acc.concat({
          title: isFunction(r.title) ? r.title(params) : r.title,
          path: `/${formatPattern(fullPath.join('/'), params)}`
        })
      }, [])
  }

  getTitle() {
    const {routes, params} = this.props
    const routeWithTitle = routes.concat().reverse().find(route => route.title)
    if (!routeWithTitle) return null
    const {title} = routeWithTitle

    if (isFunction(title)) {
      return title(params)
    } else {
      return title
    }
  }
}



// WEBPACK FOOTER //
// ./client/layouts/ConfigurationLayout/index.js